// import { Link } from 'umi';
import { Result } from 'antd';

export default () => (
  <Result
    status="403"
    title="403"
    style={{
      background: 'none',
    }}
    subTitle="抱歉，你无权访问该页面"
    // extra={
    //   <Link to="/">
    //     <Button type="primary">Back to home</Button>
    //   </Link>
    // }
  />
);
